// Mock data for Meerashi - Editorial Design

export const heroData = {
  title: "Fashion brands are more than transactions—they are experiences, narratives, and digital ecosystems.",
  subtitle: "Strategic e-commerce consulting that transforms vision into measurable growth.",
  scrollText: "(Scroll.)"
};

export const selectedWorkData = [
  {
    id: "01",
    client: "Lovebirds",
    category: "E-commerce Transformation",
    description: "Comprehensive growth strategy and conversion optimization",
    image: "https://customer-assets.emergentagent.com/job_brand-growth-expert-1/artifacts/bz220cjf_LOVEBIRDS.png",
    website: "https://lovebirds-studio.in/"
  },
  {
    id: "02",
    client: "Studio Medium",
    category: "Business Development",
    description: "Market expansion and operational excellence",
    image: "https://customer-assets.emergentagent.com/job_brand-growth-expert-1/artifacts/wa07mv4o_STUDIO%20MEDIUM.png",
    website: "https://www.studiomedium.in/"
  },
  {
    id: "03",
    client: "Divyam Mehta",
    category: "Digital Strategy",
    description: "Brand positioning and marketing execution",
    image: "https://customer-assets.emergentagent.com/job_brand-growth-expert-1/artifacts/xxnvb5ep_DIVYAM%20MEHTA.png",
    website: "https://www.divyammehta.com/"
  }
];

export const philosophyData = [
  {
    id: "01",
    title: "Growth",
    description: "Strategic roadmaps that turn ambition into sustainable revenue.",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&q=80"
  },
  {
    id: "02",
    title: "Strategy",
    description: "Data-driven insights that position your brand for long-term success.",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&q=80"
  },
  {
    id: "03",
    title: "Optimization",
    description: "Refined user experiences that convert visitors into loyal customers.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&q=80"
  },
  {
    id: "04",
    title: "Execution",
    description: "Hands-on implementation that brings strategy to life with precision.",
    image: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=600&q=80"
  }
];

export const aboutData = {
  intro: "I architect digital strategies and guide e-commerce operations for fashion brands seeking sustainable growth with modern sophistication.",
  body: "Through strategic insight and operational excellence, my work transforms brand vision into immersive digital experiences that drive measurable results and endure beyond trends.",
  image: "https://customer-assets.emergentagent.com/job_brand-growth-expert-1/artifacts/8b385c9y_Screenshot%202026-03-20%20at%204.16.00%20PM.png",
  stats: {
    growth: "70%",
    experience: "13+ Years",
    brands: "15+",
    revenue: "₹50Cr+"
  },
  linkedin: "https://www.linkedin.com/in/sakshi-jain-luxurybmanagement/"
};

export const capabilitiesData = [
  {
    title: "Business Development & Growth",
    items: [
      "Strategic roadmap development",
      "Revenue optimization",
      "Operational efficiency"
    ]
  },
  {
    title: "Conversion Rate Optimization",
    items: [
      "User experience analysis",
      "Journey optimization",
      "Performance tracking"
    ]
  },
  {
    title: "Marketing Strategy & Execution",
    items: [
      "Multi-channel campaigns",
      "Brand positioning",
      "Performance marketing"
    ]
  }
];

export const inquiryData = {
  location: "INDIA",
  tagline: "Transform your brand presence with strategic e-commerce consulting",
  email: "sakshi.jain@meerashi.com",
  phone: "+91 9769133161",
  whatsapp: "+919769133161",
  instagram: "https://www.instagram.com/meerashi.consulting/",
  image: "https://images.unsplash.com/photo-1483985988355-763728e1935b?w=1200&q=85"
};

export const pricingData = {
  title: "(Investment.)",
  description: "Every brand partnership begins with understanding unique challenges and ambitions. Investment structures are tailored to align with your growth trajectory and business objectives.",
  approach: "Flexible engagement models designed to deliver measurable results—from strategic consulting to comprehensive operational support.",
  note: "Bespoke proposals crafted upon inquiry.",
  image: "https://customer-assets.emergentagent.com/job_brand-growth-expert-1/artifacts/klbzkgdc_Screenshot%202026-03-20%20at%204.00.47%20PM.png",
  brochureUrl: "https://customer-assets.emergentagent.com/job_brand-growth-expert-1/artifacts/xywks71s_Driving-E-commerce-Growth-with-Meerashi.pdf",
  brochureName: "Driving-E-commerce-Growth-with-Meerashi.pdf"
};

export const contactData = {
  email: "sakshi.jain@meerashi.com",
  phone: "+91 9769133161",
  whatsapp: "+919769133161",
  linkedin: "https://www.linkedin.com/in/sakshi-jain-luxurybmanagement/"
};
